import { Directive, effect, EmbeddedViewRef, input, InputSignal, signal, TemplateRef, ViewContainerRef, WritableSignal } from "@angular/core";
import { FeatureFlags } from "@vierkant-software/types__api";
import { AppService } from "src/services/app.service";

@Directive({
    selector:   "[gcIsFeature]",
    standalone: false
})
export class gcIsFeatureDirective {
    gcIsFeature: InputSignal<FeatureFlags> = input();
    gcIsFeatureElse: InputSignal<TemplateRef<unknown> | null> = input();

    thenViewRef: WritableSignal<EmbeddedViewRef<unknown> | null> = signal(null);
    elseViewRef: WritableSignal<EmbeddedViewRef<unknown> | null> = signal(null);

    constructor(
        private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<unknown>,
        private app: AppService
    ) {

        effect(() => {
            this.gcIsFeatureElse();
            this.elseViewRef.set(null);
        });
        effect(() => {
            this.updateView();
        });
    }

    private updateView() {
        if (this.app.getFeature(this.gcIsFeature())) {
            if (!this.thenViewRef()) {
                this.viewContainer.clear();
                this.elseViewRef.set(null);
                if (this.templateRef)
                    this.thenViewRef.set(this.viewContainer.createEmbeddedView(this.templateRef));
            }
        } else if (!this.elseViewRef()) {
            this.viewContainer.clear();
            this.thenViewRef.set(null);
            if (this.gcIsFeatureElse())
                this.elseViewRef.set(this.viewContainer.createEmbeddedView(this.gcIsFeatureElse()));
        }
    }
}
